module.exports = __webpack_public_path__ + "4dd6fe55572003f86cc84f0728d82066.jpg";